import { render } from "./ohmic-trend-filter.vue?vue&type=template&id=6064b9c0&ts=true"
import script from "./ohmic-trend-filter.vue?vue&type=script&lang=ts"
export * from "./ohmic-trend-filter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__